<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="box-content flex-stretch relative">
      <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8; z-index: 6; min-width: 400px; border-radius: 15px;" v-show="filtering"></div>
      <div class="flex justify-end mb-3">
        <div class="pr-3-2xs pb-1 pb-0-2xs">
          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:250px;">
            <div class="multi-select-input-placeholder">
              Filter...
              <div class="dropdown-icon">
                <i class="fal fa-chevron-down"></i>
              </div>
            </div>
            <div class="multi-select-input-inner" v-show="filter_dropdown_open">
              <div class="multi-select-input-group">
                <h1 class="input-group-title">Date</h1>
                <div class="checkboxes">
                  <div class="" @click.stop>
                    <div class="input-group">
                      <div class="input-group-addon" style="width: 60px;">From:</div>
                      <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                    </div>
                    <div class="input-group mt-1">
                      <div class="input-group-addon" style="width: 60px;">To:</div>
                      <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">User Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="user_type in user_types">
                    <label>
                      <input type="checkbox" name="user_types" :value="user_type.id" v-model="selected_user_types">
                      <span class="checkbox-label">{{ user_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Categories</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="activity_log_category in activity_log_categories">
                    <label>
                      <input type="checkbox" name="activity_types" :value="activity_log_category.id" v-model="selected_activity_log_categories">
                      <span class="checkbox-label">{{ activity_log_category.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Company Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="company_type in all_company_types">
                    <label>
                      <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">
                      <span class="checkbox-label">{{ company_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">System Type</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="system_type in all_system_types">
                    <label>
                      <input type="checkbox" name="company_types" :value="system_type.id" v-model="selected_system_types">
                      <span class="checkbox-label">{{ system_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <input type="text" placeholder="Search" class="form-control" v-model="search_query">
        </div>
      </div>
      <div v-if="total_count === 0">
        No Results Found
      </div>
      <div class="activity-logs-list">
        <div v-for="log in activity_logs" class="activity-log">
          <div class="timestamp">
            {{ log.created_at }} @{{ log.formatted_time }}
          </div>
          <div class="info">
            <div class="name">
              <template v-if="!log.user_deleted && !log.company_deleted">
                <a :href="`/manage-customer/${log.user_id}`" target="_blank">
                  {{ log.company_name }} ({{ log.company_type }}) - {{ log.user_name }}
                </a>
              </template>
              <template v-else>
                <div>
                  <span class="txt-danger txt-sm">(User Deleted)</span> {{ log.company_name }} ({{ log.company_type }}) - {{ log.user_name }}
                </div>
              </template>
            </div>
            <div class="category">
              {{ log.activity_log_category }}
            </div>
            <div class="description">
              {{ log.description }}
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-bar wrapper mb-3 mt-3" v-show="total_count > 0">
        <div class="row">
          <div class="col">
            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                class="fa fa-caret-left"></i></a>
            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
          </div>
          <div class="col align-right">
            <div class="mt-1 mb-1">
              {{ total_count }} results found
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  async mounted() {
    let starting_date = new Date();
    starting_date.setMonth(starting_date.getMonth() - 1);
    this.date_filter_start = starting_date;

    if (window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }
    await this.loadActivityLogs();
  },
  props: [
    'user_id',
    'company_id',
    'activity_log_categories',
    'all_company_types',
    'all_system_types',
    'user_types',
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      activity_logs: [],
      search_query: '',
      loading: true,
      filter_dropdown_open: false,
      filtering: false,
      date_filter_start: null,
      date_filter_end: new Date(),
      selected_activity_log_categories: [],
      selected_system_types: [],
      selected_company_types: [],
      selected_user_types: [],
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      limit: 50,
    }
  },
  methods: {
    loadActivityLogs: _.debounce(function () {
      axios.post('/activity-logs/loadActivityLogs', {
        page_number: this.current_page,
        limit: this.limit,
        search_query: this.search_query,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        selected_activity_log_categories: this.selected_activity_log_categories,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        selected_user_types: this.selected_user_types,
      }).then((response) => {
        this.activity_logs = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
        this.filtering = false;
      });
    }, 500),
    setPageHash() {
      window.location = `#${this.current_page}`;
    },
    prevPage() {
      this.filtering = true;
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadActivityLogs();
    },
    nextPage() {
      this.filtering = true;
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadActivityLogs();
    }
  },
  watch: {
    search_query() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    date_filter_start() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    date_filter_end() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    selected_activity_log_categories() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    selected_company_types() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    selected_system_types() {
      this.filtering = true;
      this.loadActivityLogs();
    },
    selected_user_types() {
      this.filtering = true;
      this.loadActivityLogs();
    },
  },
};
</script>
